import React from "react";
import FlatButton from "./FlatButton";
import RaisedButton from "./RaisedButton";
import Spinner from "./Spinner";
import { createNewProject } from "../firebase/firestore";
import TextInput from "./TextInput";

class AddProjectDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCreating: false };

    this.refInputName = React.createRef();
  }

  addProject() {
    if (!this.refInputName.current.state.isValid) return;

    this.setState({ isCreating: true });
    const name = this.refInputName.current.state.value;
    const { client, history, account } = this.props;

    createNewProject(
      account.id,
      name,
      client,
      snap => {
        history.push(`${client}/manage/${snap.id}`);
      },
      error => {
        this.setState({ isCreating: false });
      }
    );
  }

  render() {
    const { isCreating } = this.state;

    if (isCreating) {
      return this.renderWorking();
    } else {
      return this.renderDefault();
    }
  }

  renderDefault() {
    const { visible, onClose } = this.props;

    const classes = "DialogBackdrop" + (visible ? "" : " DialogHide");

    return (
      <div className={classes}>
        <div className="DialogPanel">
          <div id="Head">
            Neues Projekt
            <i className="fas fa-times" onClick={() => onClose()} />
          </div>
          <TextInput
            placeholder="Projekt Name"
            minLength={5}
            maxLength={40}
            ref={this.refInputName}
          />
          <br />
          <div id="Foot">
            <RaisedButton label="Erstellen" onClick={() => this.addProject()} />
            <FlatButton label="Abbrechen" onClick={() => onClose()} />
          </div>
        </div>
      </div>
    );
  }

  renderWorking() {
    return (
      <div className="DialogBackdrop">
        <div className="DialogPanel">
          <div id="Head">Neues Projekt</div>
          <center>
            <Spinner />
          </center>
        </div>
      </div>
    );
  }
}

export default AddProjectDialog;



// WEBPACK FOOTER //
// ./src/components/AddProjectDialog.js